<div class="body">
    <br/>
    <div class="row">

        <div class="col-lg-12">
            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <!-- <th scope="col"> Id</th> -->  
                            <th scope="col"> Correlativo</th>
                            <th scope="col"> Estado</th>                                                 
                            <th scope="col"> Tipo Documento</th>                           
                            <th scope="col"> Obtener documento </th>      
                        </tr>

                    </thead>
                   
                    <tbody>
                        <tr [class] = "i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor = "let docu of afiliado.documentos; let i = index">
                     
                             <!-- <td>{{docu.id}}</td>   -->   
                             <td>{{docu.correlativo}}</td>                       
                             <td>{{docu.tipoEstado}}</td>
                             <td>{{docu.tipo}}</td>
                        
                            
                            <td> <button class = "mat-raised-button btn-info" (click) = "onDescargarArchivosClick(docu.ubicacion)">
                                <i class = "fa fa-download"> </i> Descargar Archivo Ingresado</button>
                               </td>
                           
                        
                        </tr>

                    </tbody>
            
                </table>
            </div>


        </div>

        <div class="col-lg-3"> </div>

    </div>

    <!--/form-->